import React, {useEffect} from 'react'
import Navbar from '../component/Navbar';
import Fotter from '../component/Fotter';
const Termsandcondition = () => {
    useEffect(() => {
        document.title = 'AN-TECH - TERMS AND CONDITION'; // Change the title as desired
        // Make sure to replace 'Your Website Name' with your actual website name
      }, []);
  return (
  <>
<Navbar/>

<section className="bg-gray-900 text-white body-font">
      <div className="container px-2 py-24 mx-auto">
        <div className="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">

          <p className="leading-relaxed text-lg">
            <span className='text-indigo-500 text-2xl font-bold'>1. Services: </span>
            AN-TECH provides web development, graphics design, video editing, and promotion services.
            Project details are outlined in separate agreements.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>2. Payment: </span>
            Payment terms are specified in project agreements.
            Upfront payment or deposit may be required.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3. Project Timeline: </span>
            Estimated timelines provided; subject to change.
            Client delays may affect project deadlines.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>4. Client Responsibilities: </span>
            Provide required information, materials, and non-infringing content.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>5. Revisions and Changes: </span>
            Limited revisions; additional revisions may incur costs.
            Major scope changes may impact cost and timeline.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>6. Intellectual Property: </span>
            AN-TECH retains ownership unless otherwise agreed.
            Client receives a usage license upon full payment.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>7. Confidentiality: </span>
            Both parties agree to maintain project confidentiality.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>8. Termination: </span>
            Either party can terminate for breach with written notice.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>9. Limitation of Liability: </span>
            AN-TECH's liability is capped at project fees paid.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>10. Changes to Terms: </span>
            AN-TECH may update terms with prior notice.
          </p>


        </div>
      </div>
    </section>

<Fotter/>
</>
  )
}

export default Termsandcondition